import { FormEvent, useState } from 'react';
import { ArrowRight, Mail } from 'lucide-react';

export default function EarlyAccessForm() {
  const [message, setMessage] = useState('');

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = String(data.get('email') || '').trim();
    setMessage(email ? 'You are on the early release interest list. Connection flow coming soon.' : 'Enter your email to join the early release list.');
  }

  return (
    <section id="early-access" className="email-capture section-container py-16 sm:py-24" aria-labelledby="early-access-title">
      <div className="liquid-panel mx-auto max-w-5xl overflow-hidden p-6 text-center sm:p-10">
        <div className="mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-gradient-to-br from-violet-500 to-rose-500 text-white shadow-lg">
          <Mail size={24} aria-hidden="true" />
        </div>
        <h2 id="early-access-title" className="mt-5 text-3xl font-extrabold tracking-[-0.04em] text-slate-950 sm:text-5xl">Be among the first to experience Relate.ai.</h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg leading-8 text-slate-600">Get early access, product updates, and exclusive previews.</p>
        {/* Future integration: post to Relate.IntakeGateway / n8n webhook */}
        <form onSubmit={handleSubmit} className="mx-auto mt-8 flex max-w-2xl flex-col gap-3 rounded-[2rem] border border-white/80 bg-white/74 p-2 shadow-glass sm:flex-row" noValidate>
          <label htmlFor="email" className="sr-only">Email address</label>
          <input id="email" name="email" type="email" inputMode="email" placeholder="Enter your email" className="min-h-14 flex-1 rounded-full border border-transparent bg-white/65 px-5 text-base font-semibold text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-violet-300 focus:bg-white" aria-describedby="privacy-note form-message" />
          <button type="submit" className="brand-button gap-2 whitespace-nowrap">Join the Early Release <ArrowRight size={18} aria-hidden="true" /></button>
        </form>
        <p id="privacy-note" className="mt-4 text-sm font-semibold text-slate-500">We respect your privacy. Unsubscribe anytime.</p>
        <p id="form-message" className="mt-2 min-h-5 text-sm font-bold text-violet-700" aria-live="polite">{message}</p>
      </div>
    </section>
  );
}
